<script setup lang="ts">
import AmountWithZeroHandler from "~/components/component/Product/AmountWithZeroHandler.vue";
import type {InputField} from "~/constants/types/serviceInputs";
import CartAmountHandler from "~/components/component/Product/CartAmountHandler.vue";

const props = defineProps({
  field: {
    type: Object as () => InputField,
    default: null,
  },
  canBlur: {
    type: Boolean,
    default: true,
  },
  readonlyInput: {
    type: Boolean,
    default: false,
  },
  max: {
    type: Number,
    default: null,
  },
});

</script>

<template>
  <div class="flex items-center gap-3 justify-between border-b border-secondary-400 py-3">
    <p class="md:text-base text-sm font-semibold">{{ $t(`order.${field.label}`) }}</p>

    <CartAmountHandler
        v-model="field.default_value "
        :canBlur="canBlur"
        @change=""
        @click.stop
        :max="props.max ?? props.field?.validation_rules?.max"
        :min="props.field?.validation_rules?.min"
        :readonly-input="readonlyInput"
    />
  </div>
</template>

<style scoped>

</style>